import { logout } from '@/api/calls/auth';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useNavigate } from 'react-router';
import { clearAuthFlag } from './useAuthStatus';

export const useLogout = () => {
  const queryClient = useQueryClient();
  const navigate = useNavigate();

  const mutation = useMutation({
    mutationFn: logout,
    onSuccess: () => {
      clearAuthFlag(); // Clear the login flag
      queryClient.setQueryData(['auth-status'], false);
      queryClient.invalidateQueries({ queryKey: ['auth-status'] });
      queryClient.clear();

      navigate('/');
    },
    onError: _error => {
      // Even if API call fails, clear local state and redirect
      clearAuthFlag(); // Clear the login flag
      queryClient.setQueryData(['auth-status'], false);
      queryClient.invalidateQueries({ queryKey: ['auth-status'] });
      queryClient.clear();
      navigate('/');
    },
  });

  return {
    logout: mutation.mutate,
    isLoading: mutation.isPending,
    error: mutation.error,
  };
};
